// removed by extract-text-webpack-plugin
module.exports = {"resetPassword-container":"index__resetPassword-container___2fEP8","resetPassword-actions-container":"index__resetPassword-actions-container___ZBrXQ","resetPassword-content":"index__resetPassword-content___3XrOn","resetPassword-content-text":"index__resetPassword-content-text___kc1de","resetPassword-content-email":"index__resetPassword-content-email___HNm-Q","resetPassword-form-label":"index__resetPassword-form-label___3Rnkc","resetPassword-form-input":"index__resetPassword-form-input___FHBYL","signInBtn":"index__signInBtn___1SkAT"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Auth/ResetPassword/index.less
// module id = 680
// module chunks = 3